import {BuildingSummary} from "../../../common/model/building-summary";
import {Action} from '../../../common/model/action';

export type BuildingId = string;
export class ActionsPerBuilding {
    private readonly mapping = new Map<BuildingId, [BuildingSummary, Action[]]>();
    public get buildingGuids(): string[] {
        return Array.from(this.mapping.keys());
    }
    public get all() {
        return Array.from(this.mapping.values());
    }
    public add(building: BuildingSummary, actions: Action[]): void {
        const filteredActions = actions.filter(
            action => this.buildingIdFor(action) === building.id)
        ;
        this.mapping.set(building.guid, [building, filteredActions]);
    }

    private buildingIdFor(action: Action) {
        return parseInt(action.issues[0]?.issueBuildingId) ?? null;
    }

    private actionsForBuilding(buildingStructureId: BuildingId) {
        return this.mapping.get(buildingStructureId) ?? [];
    }

}
